import React, { useEffect, useState } from "react";

import * as S from "./styles";
import { getOrderById } from "../../api/orders";
import { Alert, Spinner } from "reactstrap";
import moment from "moment-timezone";
import { Col2Grid, Label, Text, Title } from "../../routes/main-styles";
import Stepper from "../Stepper";
import Timeline from "../Timeline";

function OrderViewer({ id_pedido, id_user, withTimeline = true }) {
  const [loading, setLoading] = useState(true);
  const [pedido, setPedido] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!id_pedido) {
      console.error("No order ID provided");
      return;
    }
    loadPedido();
  }, [id_pedido]);

  async function loadPedido() {
    let npedido = await getOrderById(id_pedido);
    if (npedido) {
      setPedido(npedido);
      setLoading(false);
    } else {
      console.error("Order not found");
      setLoading(false);
    }
  }

  if (loading) {
    return <Spinner />;
  }
  const ultimaAtualizacao = Object.values(pedido?.historico).reduce((a, b) => {
    if (a?.date > b?.date) {
      return a.date;
    }
    return b.date;
  }, null);
  const valorOrgadots = parseFloat(pedido.valor_orgadots) || 0;
  const valorFaturado = (parseFloat(pedido.value) || 0) - valorOrgadots;
  return (
    <S.Container withTimeline={withTimeline}>
      <S.Left withTimeline={withTimeline}>
        <Col2Grid style={{ gap: 0 }}>
          <Label>
            <strong>Data de Criação:</strong>{" "}
            {moment(pedido.created_at).format("DD/MM/YYYY HH:mm:ss")}
          </Label>
          <Label>
            <strong>
              Última atualização:{" "}
              {moment(ultimaAtualizacao).format("DD/MM/YYYY HH:mm:ss")}
            </strong>
          </Label>
          <Text>
            <strong>ID PEDIDO:</strong> #{pedido.id}{" "}
            {pedido.id_pedido_everest &&
              `(ID no Everest: ${pedido.id_pedido_everest})`}
          </Text>
          <Text>
            <strong>Valor Total: </strong>R${" "}
            {parseFloat(pedido.value).toFixed(2)}
          </Text>
          <Text style={{ opacity: valorOrgadots > 0 ? 1 : 0.9 }}>
            <strong>Pago em OrgaDots: </strong>
            {valorOrgadots.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Text>
          <Text style={{ opacity: valorOrgadots > 0 ? 1 : 0.9 }}>
            <strong>Valor Faturado: </strong>R$ {valorFaturado.toFixed(2)}
          </Text>
        </Col2Grid>
        <hr />
        {pedido.current_status === "cancelado" ? (
          <Alert color="warning" style={{ fontSize: 12 }}>
            <strong>Pedido Cancelado</strong>
            <br />
            Motivo:
            <br />
            {pedido.reason || "Nenhum motivo informado."}
          </Alert>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Stepper step={pedido.current_status} size={14} />
          </div>
        )}
        <hr />
        <Col2Grid style={{ gap: 0 }}>
          <Title>Dados do Distribuidor</Title>
          <div />
          <Label>
            <strong>ID:</strong> {pedido.id_user}
          </Label>
          <Label>
            <strong>Username:</strong> @{pedido.user.username}
          </Label>
          <Label>
            <strong>Nome:</strong> {pedido.user.name} {pedido.user.last_name}
          </Label>
          <Label>
            <strong>Email:</strong> {pedido.user.email}
          </Label>
          <Label>
            <strong>Telefone:</strong> {pedido.user.phone}
          </Label>
        </Col2Grid>

        <hr />
        <Title>Itens do Pedido</Title>
        <table
          className="table table-sm"
          style={{
            fontSize: 12,
          }}
        >
          <thead>
            <tr>
              <th scope="col">ID Produto</th>
              <th scope="col">Nome</th>
              <th scope="col">Quantidade</th>
              <th scope="col">Valor Unitário</th>
              <th scope="col">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {pedido.itens.map((item) => (
              <tr key={item.id_produto}>
                <td>{item.id_produto}</td>
                <td>{item.nome}</td>
                <td>{item.quantidade}</td>
                <td>R$ {parseFloat(item.valor).toFixed(2)}</td>
                <td>
                  R$ {(parseFloat(item.valor) * item.quantidade).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="4" style={{ textAlign: "right" }}>
                Total:
              </td>
              <td>R$ {parseFloat(pedido.value).toFixed(2)}</td>
            </tr>
            <tr style={{ opacity: valorOrgadots > 0 ? 1 : 0.9 }}>
              <td colSpan="4" style={{ textAlign: "right" }}>
                Pago em OrgaDots:
              </td>
              <td>
                {valorOrgadots.toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
            </tr>
            <tr style={{ opacity: valorOrgadots > 0 ? 1 : 0.9 }}>
              <td colSpan="4" style={{ textAlign: "right" }}>
                Valor Faturado:
              </td>
              <td>R$ {valorFaturado.toFixed(2)}</td>
            </tr>
          </tfoot>
        </table>
        <hr />
      </S.Left>
      {withTimeline && (
        <S.Right>
          <Timeline items={pedido.historico} />
        </S.Right>
      )}
    </S.Container>
  );
}

export default OrderViewer;
